module.exports = "/10/3-mot-so-thao-tac-ghi-du-lieu-vao-file-trong-c/index.html.c8113e95b02255a9a61577404e412330.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/35622.md
 ** module id = 588
 ** module chunks = 0
 **/